import { css } from "styled-components";

export const pauseStyle = css`
  .pauseButton[data-wordtype] {
    border: 1px solid #ddd;
    min-width: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    cursor: pointer;
    margin: 0 auto;
    border-radius: 6px;
    text-align: center;
    vertical-align: bottom;
    background-color: #ffc700;
    position: relative;
    box-shadow: 0px 0px 6px 0px #0000001A;

    font-size: 12px;
  }

  .pauseButton[data-wordtype]::before {
    content: '⏳';
    color: white;
    font-size: 10px;
  }
`
